"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPEN_SEARCH_BY_TITLE = exports.OPEN_SEARCH_BY_PROVIDER = exports.SELECTED_COLLECTION = void 0;
exports.SELECTED_COLLECTION = 'selected_collection';
exports.OPEN_SEARCH_BY_PROVIDER = 'open_search_by_provider';
exports.OPEN_SEARCH_BY_TITLE = 'open_search_by_title';
